import { jsx as _jsx } from "react/jsx-runtime";
import { getTestId } from '@airtel/air-design-system';
import { UploadFileWidget } from '../../../../../upload-file-widget';
export var FileUploadSection = props => {
  var type = props.type,
    showFiles = props.showFiles,
    fileUpload = props.fileUpload,
    uploadFileProof = props.uploadFileProof,
    handleFileUpload = props.handleFileUpload,
    handleDeleteIconPress = props.handleDeleteIconPress,
    testID = props.testID,
    variant = props.variant,
    handleActionCtaPress = props.handleActionCtaPress,
    style = props.style;
  return _jsx(UploadFileWidget, Object.assign({}, uploadFileProof, {
    allowFileUploadOnWeb: true,
    hideOnUpload: true,
    onUserAction: function onUserAction(_) {
      for (var _len = arguments.length, metaData = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        metaData[_key - 1] = arguments[_key];
      }
      return handleFileUpload(metaData, type);
    },
    uploadedFiles: showFiles ? [Object.assign(Object.assign({}, fileUpload), {
      handleDeletePress: () => handleDeleteIconPress(type),
      actionCtaIconName: 'ReloadButtonIcon',
      handleActionCtaPress,
      showDeleteIcon: (fileUpload === null || fileUpload === void 0 ? void 0 : fileUpload.state) !== 'error' && !(uploadFileProof === null || uploadFileProof === void 0 ? void 0 : uploadFileProof.isUploading) && !(uploadFileProof === null || uploadFileProof === void 0 ? void 0 : uploadFileProof.errorText),
      state: (uploadFileProof === null || uploadFileProof === void 0 ? void 0 : uploadFileProof.errorText) ? 'error' : fileUpload === null || fileUpload === void 0 ? void 0 : fileUpload.state,
      hintText: (uploadFileProof === null || uploadFileProof === void 0 ? void 0 : uploadFileProof.errorText) || (fileUpload === null || fileUpload === void 0 ? void 0 : fileUpload.hintText),
      actionCtaText: ((fileUpload === null || fileUpload === void 0 ? void 0 : fileUpload.state) === 'error' || (uploadFileProof === null || uploadFileProof === void 0 ? void 0 : uploadFileProof.errorText)) && !(uploadFileProof === null || uploadFileProof === void 0 ? void 0 : uploadFileProof.isUploading) && 'RETRY',
      isLoading: uploadFileProof === null || uploadFileProof === void 0 ? void 0 : uploadFileProof.isUploading
    })] : []
  }, getTestId(testID, variant + "_" + type + "FileWidget"), {
    style: style
  }));
};